import { render, staticRenderFns } from "./AccidentIntakeHowYouFeltForm.vue?vue&type=template&id=3f5ec228&scoped=true"
import script from "./AccidentIntakeHowYouFeltForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeHowYouFeltForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakeHowYouFeltForm.vue?vue&type=style&index=0&id=3f5ec228&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5ec228",
  null
  
)

export default component.exports